import { type ReactNode, type HTMLAttributes } from 'react';
import ContentAside from './ContentAside';
import ContentBody from './ContentBody';

interface ContentProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
}

const Content = ({ children, className = '', ...props }: ContentProps) => (
  <div className={`content ${className}`} {...props}>
    {children}
  </div>
);

Content.Aside = ContentAside;
Content.Body = ContentBody;

export default Content;
